// src/components/StudentReg.js
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const StudentReg = ({ fetchStudents, handleClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    contact: '',
    file: null,
    username: '',
    institute: '',
    country: '',
    dob: '',
    educationLevel: '',
    department:'',
    major: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      file: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      for (const key in formData) {
        form.append(key, formData[key]);
      }
  
      const response = await axios.post('https://backend.writerswright.com/api/v1/student/register', form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.data.message === "User and student registered successfully") {
        setFormData({
          name: '',
          surname: '',
          email: '',
          contact: '',
          file: null,
          username: '',
          institute: '',
          country: '',
          dob: '',
          educationLevel: '',
          department: '',
          major: '',
        });
        alert("Student registered successfully");
      }
  
      console.log(response.data);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Server responded with an error:', error.response.data);
        alert(`Error: ${error.response.data.message || 'An error occurred while registering the student.'}`);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received:', error.request);
        alert('Error: No response received from the server. Please try again later.');
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error setting up the request:', error.message);
        alert(`Error: ${error.message}`);
      }
    }
  };
  
 return (
    <div 
    className="d-flex flex-column justify-content-center align-items-center vh-100 " 
    style={{ background: '#f8f9fa' }}
  >
    <div 
      style={{
        maxWidth: '800px',
        width: '100%',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: 'white',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
      }}
    >
 <h2 className="mb-4 text-center title">Student Registration</h2>
      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="name" className="form-label text">Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="surname" className="form-label text">Surname</label>
            <input
              type="text"
              className="form-control"
              id="surname"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="email" className="form-label text">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="contact" className="form-label text">Contact</label>
            <input
              type="text"
              className="form-control"
              id="contact"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="profilePicture" className="form-label text">Profile Picture</label>
            <input
              type="file"
              className="form-control"
              id="profilePicture"
              name="profilePicture"
              onChange={handleFileChange}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="username" className="form-label text">Username</label>
            <input
              type="text"
              className="form-control"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="institute" className="form-label text">Institute</label>
            <input
              type="text"
              className="form-control"
              id="institute"
              name="institute"
              value={formData.institute}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="country" className="form-label text">Country</label>
            <input
              type="text"
              className="form-control"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="dob" className="form-label text">Date of Birth</label>
            <input
              type="date"
              className="form-control"
              id="dob"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="educationLevel" className="form-label text">Level of Education</label>
            <select
              className="form-select"
              id="educationLevel"
              name="educationLevel"
              value={formData.educationLevel}
              onChange={handleChange}
              required
            >
              <option value="">Choose...</option>
              <option value="High School">High School</option>
              <option value="Undergraduate">Undergraduate</option>
              <option value="Postgraduate">Postgraduate</option>
              <option value="Doctorate">Doctorate</option>
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="major" className="form-label text">Major</label>
            <select
              className="form-select"
              id="major"
              name="major"
              value={formData.major}
              onChange={handleChange}
              required
            >
              <option value="">Choose...</option>
              <option value="Computer Science">Computer Science</option>
              <option value="Engineering">Engineering</option>
              <option value="Business">Business</option>
              <option value="Arts">Arts</option>
              <option value="Sciences">Sciences</option>
            </select>
          </div>



          <div className="col-md-6">
            <label htmlFor="department" className="form-label text">Department</label>
            <input
              type="text"
              className="form-control"
              id="department"
              name="department"
              value={formData.department}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button 
            className="button-37" 
            role="button" 
            style={{ width: "100%", marginTop: "9px" }}
          >
            Submit
          </button>
        </form>
    </div>
    </div>
  );
};

export default StudentReg;
